import { render, staticRenderFns } from "./PhoneCodeItem.vue?vue&type=template&id=67476f6c&scoped=true&"
import script from "./PhoneCodeItem.vue?vue&type=script&lang=js&"
export * from "./PhoneCodeItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=67476f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67476f6c",
  null
  
)

export default component.exports